import { render, staticRenderFns } from "./import-price-lists.vue?vue&type=template&id=4aa9da86"
import script from "./import-price-lists.vue?vue&type=script&lang=js"
export * from "./import-price-lists.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports